import React from 'react'
import { Box, Grid, Skeleton, Theme } from '@mui/material'


const appStyles = {
    root: {
        boxShadow: (theme: Theme) => `0px 0px 0px 1px ${theme.palette.grey[300]}`,
        p: 2,
        borderRadius: '0.4em',
        backgroundColor: (theme: Theme) => theme.palette.common.white,
    },
    bg: {
        backgroundColor: '#FAFAFA',
        p: 2
    }
};

const GroupSummariesLoader = () => {
    return (
        <Box sx={{
            ...appStyles.root,
        }}>
            <Grid
                container
                spacing={4}
            >
                {
                    Array.from({ length: 3 }).map((_, index) => (
                        <Grid key={index} item xs={12} sm={6} md={4}>
                            <Box sx={appStyles.bg}>
                                <Skeleton variant="text" width="100%" height={30} />
                                <Skeleton variant="text" width="80%" height={30} />
                            </Box>
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}

export default GroupSummariesLoader